"use client";

// Route-segment error boundary. Without this, any thrown render error on a
// management/studio route showed Next's raw unstyled error page with no way
// back. Branded + offers retry (reset) and a route home.
import { useEffect } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function RouteError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		console.error("[route-error]", error);
	}, [error]);

	return (
		<div className="min-h-screen bg-background text-foreground flex items-center justify-center px-6">
			<div className="flex flex-col items-center gap-5 text-center max-w-md">
				<div className="bg-destructive/10 text-destructive rounded-full size-14 flex items-center justify-center text-2xl">
					!
				</div>
				<div className="flex flex-col gap-2">
					<h1 className="text-xl font-semibold">Something went wrong</h1>
					<p className="text-muted-foreground text-sm">
						This page hit an unexpected error. Your work is saved — try again, or
						head back to your dashboard.
					</p>
					{error?.digest && (
						<p className="text-muted-foreground/60 text-[11px] font-mono">
							ref: {error.digest}
						</p>
					)}
				</div>
				<div className="flex items-center gap-3">
					<Button onClick={() => reset()}>Try again</Button>
					<Button asChild variant="outline">
						<Link href="/dashboard">Back to dashboard</Link>
					</Button>
				</div>
			</div>
		</div>
	);
}
